<template>
    <div class="app pb-5">
        <div class="brand-line"></div>

        <main>
            <nuxt />
        </main>
		<client-only>
			<CookieBanner @open-settings="showCookieSettings = true" />
			<CookieSettingsModal
				v-if="showCookieSettings"
				@close="showCookieSettings = false"
			/>
		</client-only>
    </div>
</template>
<script>
import CookieBanner from '~/components/ui/banners/CookieBanner'
import CookieSettingsModal from '~/components/ui/modals/CookieSettingsModal'
import { PUBLIC_SEO_DESCRIPTION, PUBLIC_SEO_TITLE } from '~/constants/seo'

export default {
	components: {
		CookieBanner,
		CookieSettingsModal
	},
	data() {
		return {
			showCookieSettings: false
		}
	},
	head() {
		return {
			title: PUBLIC_SEO_TITLE,
			titleTemplate: chunk => chunk || PUBLIC_SEO_TITLE,
			meta: [
				{
					hid: 'description',
					name: 'description',
					content: PUBLIC_SEO_DESCRIPTION
				},
				{
					hid: 'og:title',
					property: 'og:title',
					content: PUBLIC_SEO_TITLE
				},
				{
					hid: 'og:description',
					property: 'og:description',
					content: PUBLIC_SEO_DESCRIPTION
				},
				{
					hid: 'twitter:title',
					name: 'twitter:title',
					content: PUBLIC_SEO_TITLE
				},
				{
					hid: 'twitter:description',
					name: 'twitter:description',
					content: PUBLIC_SEO_DESCRIPTION
				},
				{ hid: 'robots', name: 'robots', content: 'index, follow' }
			]
		}
	}
}
</script>
